import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useGetIdentitasQuery } from "../IdentitasSekolah/identitasApiSlice";
import {
  selectCurrentUser,
  selectSelectedSchoolUuid,
  setSchoolUuid,
} from "../../features/auth/authSlice";
import { apiSlice } from "../../app/api/apiSlice";
import { useGetSchoolsQuery } from "../../features/school/schoolApiSlice";
import ROLES_LIST from "../../RoleList.mjs";

const Navbar = ({
  handleDrawerToggle,
  desktopOpen = true,
  handleDesktopToggle,
  mobileOpen = false,
}) => {
  const { data: identitasData } = useGetIdentitasQuery();
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const selectedSchoolUuid = useSelector(selectSelectedSchoolUuid);

  const isAdmin = user?.roles?.includes(ROLES_LIST.ADMIN);
  const isYayasanPM = user?.roles?.includes(ROLES_LIST.YAYASAN);
  const canSwitchSchool = isAdmin || isYayasanPM;
  const { data: schools } = useGetSchoolsQuery(undefined, { skip: !canSwitchSchool });

  const schoolName = isAdmin || isYayasanPM
    ? "Yayasan Al Hasanah Bengkulu"
    : identitasData?.identitas?.[0]?.strNamaSekolah || "";
  const handleSchoolChange = (event) => {
    dispatch(setSchoolUuid(event.target.value));
    dispatch(
      apiSlice.util.invalidateTags([
        "Kelas",
        "Siswa",
        "HasilRaport",
        "DetailRaport",
        "Organization",
      ])
    );
  };

  return (
    <AppBar
      position="fixed"
      sx={(theme) => ({
        zIndex: { xs: theme.zIndex.appBar, sm: theme.zIndex.drawer + 1 },
        width: { sm: desktopOpen ? `calc(100% - 260px)` : "100%" },
        ml: { sm: desktopOpen ? `260px` : 0 },
        bgcolor: "#51A8B1",
        transition: "margin 0.3s, width 0.3s",
      })}
    >
      <Toolbar
        sx={{
          height: { xs: "64px", sm: "130px" },
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Desktop Toggle Button (Hover to show) */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            height: "100%",
            width: "40px",
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            justifyContent: "center",
            opacity: 0,
            transition: "opacity 0.2s",
            "&:hover": {
              opacity: 1,
              bgcolor: "rgba(0,0,0,0.05)",
            },
            zIndex: 10,
          }}
        >
          <Tooltip title={desktopOpen ? "Tutup Sidebar" : "Buka Sidebar"}>
            <IconButton color="inherit" onClick={handleDesktopToggle}>
              {desktopOpen ? <ChevronLeft /> : <ChevronRight />}
            </IconButton>
          </Tooltip>
        </Box>

        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          {mobileOpen ? <ChevronLeft /> : <ChevronRight />}
        </IconButton>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            alignItems: "center",
            py: 1,
          }}
        >
          {schoolName && (
            <Typography
              variant="h4"
              noWrap
              component="div"
              sx={{
                lineHeight: 1.2,
                fontWeight: "bold",
                letterSpacing: { xs: 1, sm: 3 },
                mb: { xs: 0, sm: 1 },
                fontSize: { xs: "1rem", sm: "2.125rem" },
              }}
            >
              {schoolName}
            </Typography>
          )}
          <Typography
            variant="h5"
            noWrap
            component="div"
            sx={{
              lineHeight: 1.2,
              letterSpacing: { xs: 1, sm: 2 },
              fontSize: { xs: "0.875rem", sm: "1.5rem" },
            }}
          >
            E-Raport
          </Typography>
          {canSwitchSchool && (
            <FormControl sx={{ mt: 1, minWidth: 200 }} size="small">
              <Select
                value={selectedSchoolUuid || ""}
                onChange={handleSchoolChange}
                displayEmpty
                inputProps={{ "aria-label": "Select School" }}
                sx={{ bgcolor: "white", borderRadius: 1 }}
              >
                <MenuItem value="">
                  <em>Semua Sekolah</em>
                </MenuItem>
                {schools?.map((school) => (
                  <MenuItem key={school.uuid} value={school.uuid}>
                    {school.strNamaSekolah}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
